import React from 'react';

import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

function QuotaBreakdownHeader() {
  return (
    <TableHead>
      <TableRow>
        <TableCell variant="head">Category</TableCell>
        <TableCell variant="head">Base</TableCell>
        <TableCell variant="head">Total Growth</TableCell>
        <TableCell variant="head">PCI</TableCell>
        <TableCell variant="head">Tier 2 Start</TableCell>
        <TableCell variant="head">Tier 3 Start</TableCell>
        <TableCell variant="head">Sample Rate</TableCell>
        <TableCell variant="head">Total Samples Allotted</TableCell>
        <TableCell variant="head">Total Samples Used</TableCell>
        <TableCell variant="head">Yearly Quota</TableCell>
        <TableCell variant="head">EOY Bonus</TableCell>
      </TableRow>
    </TableHead>
  );
}

export default React.memo(QuotaBreakdownHeader);
